// Copyright (c) Docugami, Inc. All rights reserved.

import { Stack } from '@fluentui/react';
import { ReportContextSwitcher } from 'components/work_path/ReportContextSwitcher';
import { ReportViewContext } from 'networking/reportsApi';
import { AgGridReportTable } from './AgGridReportTable';

export interface TableViewProps {
    className?: string;
    currentContext?: ReportViewContext;
    onContextChange: (context: ReportViewContext) => void;
}

export const ReportTable = (props: TableViewProps): JSX.Element => {
    return (
        <Stack styles={{ root: { width: '100%', height: '100%' } }}>
            <ReportContextSwitcher
                currentContext={props.currentContext}
                onContextChange={props.onContextChange} />
            <AgGridReportTable className={props.className} />
        </Stack>
    );
}